import api from "@/lib/api";

export const NORMALIZE_CONFIRM_PHRASE = "NORMALIZAR COMPRADOR PRINCIPAL";
export const REASSIGN_CONFIRM_PHRASE = "REASIGNAR EMPRESAS";
export const PURGE_CONFIRM_PHRASE = "DEPURAR REGISTROS";
export const SUSPEND_CONFIRM_PHRASE = "SUSPENDER USUARIO";

export const PRIMARY_BUYER_EMAIL = "despachobnt.mty@gmail.com";
export const DESIGNER_PROTECTED_EMAIL = "pruebas@bnt.local";

export async function previewNormalizePrimaryBuyer() {
  const { data } = await api.get("/platform/safe-cleanup/normalize-primary-buyer/preview");
  return data;
}

export async function applyNormalizePrimaryBuyer(payload) {
  const { data } = await api.post("/platform/safe-cleanup/normalize-primary-buyer", payload);
  return data;
}

export async function diagnoseSafeCleanupClients() {
  const { data } = await api.get("/platform/safe-cleanup/clients/diagnose");
  return data;
}

export async function previewReassignClients(payload = {}) {
  const { data } = await api.post("/platform/safe-cleanup/clients/reassign/preview", payload);
  return data;
}

export async function applyReassignClients(payload) {
  const { data } = await api.post("/platform/safe-cleanup/clients/reassign", payload);
  return data;
}

export async function diagnoseSafeCleanupPurge() {
  const { data } = await api.get("/platform/safe-cleanup/purge/diagnose");
  return data;
}

export async function applySafeCleanupPurge(payload) {
  const { data } = await api.post("/platform/safe-cleanup/purge", payload);
  return data;
}

export async function applySafeCleanupSuspend(payload) {
  const { data } = await api.post("/platform/safe-cleanup/suspend", payload);
  return data;
}

export async function fetchSafeCleanupAudit(limit = 50) {
  const { data } = await api.get("/platform/safe-cleanup/audit", { params: { limit } });
  return data?.items || [];
}
